export const REGION_OPTIONS = [
  { label: "UK", value: "uk" },
  { label: "US", value: "us" },
  { label: "CAN", value: "can" },
  { label: "EU", value: "eu" },
  { label: "KSA", value: "ksa" },
  { label: "AUS", value: "aus" },
];
